import { render, staticRenderFns } from "./DraggableListsLayers.vue?vue&type=template&id=2d7a1146&scoped=true&"
import script from "./DraggableListsLayers.vue?vue&type=script&lang=js&"
export * from "./DraggableListsLayers.vue?vue&type=script&lang=js&"
import style0 from "./DraggableListsLayers.vue?vue&type=style&index=0&id=2d7a1146&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7a1146",
  null
  
)

export default component.exports